module.exports = __webpack_public_path__ + "static/media/E901.45892136.png";